// src/pages/inventory/Inventory.jsx
import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import InventoryTable from "../../components/inventory/InventoryTable";

const Inventory = () => (
    <WrapperSection>
        <GlobalBreadcrumbs />
        <InventoryTable />
    </WrapperSection>
);

export default Inventory;
